define([
	"dojo/_base/declare",
	"csi/xml",
	"csi/action/Controller",
	"SiteAdmin/_UTC"
], function(declare,xml,Controller,_UTC) {

	return declare(Controller, {
		toWriterRequest: function() {
			var	call = this.inherited(arguments);
			var form = this.m_formData;
			if(form) {
				var	time = form.getFieldValue("Date", true);
				if (time) {
					var serverOffset = _UTC.getServerOffset(this.getContext());
					call.addParameter("Date", xml.ATTR_TIME, _UTC.clientToServer(time, serverOffset));
				}
				var	comment = form.getFieldValue("Comment", true);
				if (comment) {
					call.addParameter("Comment", xml.ATTR_STRING, comment);
				}
			}
			return call;
		}
	});
});